import { __decorate } from "tslib";
import { provideFeatureAddonRoutes, provideRootRoutes } from '@core/frontend-shared';
import { FrontendFeaturePlugin } from '@core/frontend-shared/feature';
import { ClassName } from '@core/shared/class-name';
import { RouterLinkResolverService } from '@core/shared/feature';
import * as i0 from "@angular/core";
let MpfAppFrontendFeature = /*#__PURE__*/(() => {
  let MpfAppFrontendFeature = class MpfAppFrontendFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@mpf/app/frontend","featureId":"mpf-app"};
    }
    getFeatureFunctionality(functionality) {
      const resolver = this.injector.get(RouterLinkResolverService);
      functionality.defineMenuItems({
        toolbar: [{
          label: 'Anmelden',
          icon: 'unlock',
          routerLink: resolver.resolveRouterLink('frontend', 'login'),
          simpleAbilityCheck: {
            allow: ['!REGISTERED']
          }
        }, {
          label: 'Profil',
          icon: 'user',
          routerLink: resolver.resolveRouterLink('frontend', 'profile'),
          simpleAbilityCheck: {
            allow: [['REGISTERED', '!MANAGER']]
          }
        }, {
          label: 'Management',
          icon: 'user',
          routerLink: resolver.resolveRouterLink('frontend', 'management'),
          simpleAbilityCheck: {
            allow: ['MANAGER']
          }
        }, {
          label: 'Kurse',
          icon: 'chalkboard-teacher',
          routerLink: resolver.resolveRouterLink('frontend', 'courses')
        }, {
          label: 'Neues',
          icon: 'bell',
          routerLink: resolver.resolveRouterLink('frontend', 'notifications'),
          simpleAbilityCheck: {
            allow: ['REGISTERED']
          },
          id: 'notifications' /* ID required to add custom notification-icon */
        }, {
          label: 'Hilfe',
          icon: 'question-circle',
          routerLink: resolver.resolveRouterLink('frontend', 'faq')
        }, {
          label: 'Menu',
          icon: 'bars',
          declareGroup: 'toolbar/more',
          items: [{
            label: 'Datenschutz',
            icon: 'user-shield',
            routerLink: 'privacy'
          }, {
            label: 'Impressum',
            icon: 'info-circle',
            routerLink: 'imprint'
          }, {
            label: 'AGB',
            icon: 'info-circle',
            routerLink: 'terms'
          }, {
            label: 'Logout',
            icon: 'lock',
            routerLink: resolver.resolveRouterLink('frontend', 'logout'),
            simpleAbilityCheck: {
              allow: ['REGISTERED']
            }
          }]
        }]
      });
      functionality.defineRouterLinkRedirects([{
        matcher: '/user/login',
        redirect: '/login',
        type: 'Replace'
      }]);
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵMpfAppFrontendFeature_BaseFactory;
        return function MpfAppFrontendFeature_Factory(__ngFactoryType__) {
          return (ɵMpfAppFrontendFeature_BaseFactory || (ɵMpfAppFrontendFeature_BaseFactory = i0.ɵɵgetInheritedFactory(MpfAppFrontendFeature)))(__ngFactoryType__ || MpfAppFrontendFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: MpfAppFrontendFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [provideRootRoutes([{
          path: 'imprint',
          data: {
            pageTitle: 'Impressum'
          },
          loadComponent: () => import('./components/imprint.component').then(m => m.MpfImprintComponent)
        }, {
          path: 'privacy',
          data: {
            pageTitle: 'Datenschutz'
          },
          loadComponent: () => import('./components/privacy.component').then(m => m.MpfPrivacyComponent)
        }, {
          path: 'terms',
          data: {
            pageTitle: 'AGB'
          },
          loadComponent: () => import('./components/terms.component').then(m => m.MpfTermsComponent)
        }]), provideFeatureAddonRoutes([{
          useAddonSlot: 'management',
          path: 'profile',
          loadChildren: () => import('@common/users/frontend/profile').then(m => m.UserProfileModule)
        }])]
      });
    }
  };
  MpfAppFrontendFeature = __decorate([ClassName("MpfAppFrontendFeature")], MpfAppFrontendFeature);
  return MpfAppFrontendFeature;
})();
export { MpfAppFrontendFeature };